import { IUpdateAction } from './types';
import { AT_UPDATE } from './constants';
import { IChat } from '../../../../../../../rest/effects/chats/chat/types';

export const updateAction = (
    chat: Partial<IChat>,
): IUpdateAction => ({
    type: AT_UPDATE,
    chat,
});
